export default __webpack_public_path__ + "static/media/Image-Slider-01.192d1b97.jpg";